import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "q-pa-md q-card column justify-between",
  style: {"width":"700px","max-width":"80vw"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { class: "q-mb-sm text-weight-bold" }, "You are trying to cancel access for agreement", -1)
const _hoisted_3 = {
  key: 0,
  class: "text-body1 q-mb-md"
}
const _hoisted_4 = {
  key: 1,
  class: "text-body1 q-mb-md"
}
const _hoisted_5 = { class: "q-gutter-md q-mt-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_agreement_form_field_end_date = _resolveComponent("agreement-form-field-end-date")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: "dialogRef",
    onHide: _ctx.onDialogHide
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("h6", null, "Member: " + _toDisplayString(_ctx.member.name), 1),
        (!_ctx.draft)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Current given date is what normal access should end. You still can pick any date but please remember to pick date with last day of access included."))
          : _createCommentVNode("", true),
        (_ctx.draft)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "This member will be deleted from draft immediately."))
          : _createCommentVNode("", true),
        _createVNode(_component_q_form, {
          greedy: "",
          onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"]),
          ref: "form"
        }, {
          default: _withCtx(() => [
            (!_ctx.draft)
              ? (_openBlock(), _createBlock(_component_agreement_form_field_end_date, {
                  key: 0,
                  modelValue: _ctx.endDateModel,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.endDateModel) = $event)),
                  isRequired: "true"
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_q_btn, {
                color: "primary",
                label: "No",
                onClick: _ctx.onCancelClick,
                outline: "",
                "no-caps": "",
                unelevated: ""
              }, null, 8, ["onClick"]),
              _createVNode(_component_q_btn, {
                color: "negative",
                label: "Yes remove",
                type: "submit",
                "no-caps": ""
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ]),
    _: 1
  }, 8, ["onHide"]))
}